import { createFileRoute } from '@tanstack/react-router';
import { seo } from '../../utils/seo';

export const Route = createFileRoute('/_layout/giveaway')({
  head: () => ({ meta: seo({ title: 'Nyereményjáték' }) }),
  component: GiveawayRoute
});

function GiveawayRoute() {
  return (
    <div className="container-fluid">
      <div className="page-content centered">
        <h1 className="page-title">Nyereményjáték</h1>
        <p>
          A nyereményjáték szabályzatát{' '}
          <a href="/nyeremenyjatek-2026-04-24.pdf" target="_blank">
            itt találod
          </a>
          .
        </p>

        {/* <h2>Játékszabályzat</h2>
        <ul>
          <li>A nyereményjáték részvételi feltétele a feltett kérdésre adott helyes válasz megírása a nyereményjáték bejegyzéséhez. A nyereményjátékban minden 18. életévét betöltött személy részt vehet, aki rendelkezik saját Facebook felhasználói fiókkal.</li>
          <li>A szerencsés nyertes 2 darab általa kiválasztott karkötőt kap ajándékba, melyet postai úton juttatunk el hozzá (postai levél vagy Foxpost csomagautomata).</li>
          <li>A játék nyertesét a helyes megfejtést adó hozzászólók között sorsoljuk ki.</li>
          <li>A nyereményjáték kezdete: 2021.10.17. - 20:00 óra</li>
          <li>A nyereményjáték vége: 2021.10.24. - 20:00 óra</li>
          <li>A nyertes kisorsolása: 2021.10.24. - 21:00 óra</li>
          <li>A sorsolás eszköze: <a href="https://socialwinner.besocial.hu">Facebook Nyertes by Be Social</a></li>
          <li>A játékban résztvevők tudomásul veszik, hogy jelen nyereményjáték promóciót a facebook nem támogatja, nem hagyta jóvá, nem kezeli, illetve semmilyen tekintetben nem kapcsolódik hozzá, egyben elfogadják a Facebook használati szabályzatát!</li>
        </ul> */}
      </div>
    </div>
  );
}
